'use client';

import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';
import { RHFCheckbox } from '@/components/checkbox/RHFCheckbox';
import { api_portalOfficeListing_filter } from '@/init/swagger';

export function SearchFilterList({
  searchFilters,
  disabled = false,
}: {
  searchFilters: api_portalOfficeListing_filter[];
  disabled?: boolean;
}) {
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexGrow: 1,
        rowGap: 2,
        columnGap: 3,
        maxWidth: '100%',
      }}
    >
      {searchFilters.map((searchFilter, index) => {
        return (
          <RHFCheckbox
            key={index}
            name={`${searchFilter.category_id}_${searchFilter.id}`}
            control={control}
            label={searchFilter.label}
            disabled={disabled}
            sx={{ p: 0 }}
          />
        );
      })}
    </Box>
  );
}
